"use client";

import { type ReactNode, useEffect } from 'react';
import { ThemeProvider } from '@/components/ThemeProvider';
import { db } from '@/lib/firebase';
import { doc, onSnapshot } from 'firebase/firestore';

export default function ClientProviders({ children }: { children: ReactNode }) {

  useEffect(() => {
    const settingsRef = doc(db, 'settings', 'app_details');
    const unsubscribe = onSnapshot(settingsRef, (docSnap) => {
      let newAppName = "SNA FIN_O2";
      if (docSnap.exists()) {
        const data = docSnap.data();
        if (data.appName) {
          newAppName = data.appName;
        }
      }
      document.title = newAppName;
    });

    return () => unsubscribe();
  }, []);

  return (
    <ThemeProvider
      attribute="class"
      defaultTheme="system"
      enableSystem
      disableTransitionOnChange
    >
      {children}
    </ThemeProvider>
  );
}
